import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { darken } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";

export default function QuickActionDial({
  onStartFeeding,
  onStopFeeding,
  activeFeeding,
  onStartSleep,
  onStopSleep,
  activeSleep,
  onStartTummyTime,
  onStopTummyTime,
  activeTummyTime,
  onStartDiaper,
  onStartExtractedMilk,
  onAddMedicine,
  visibleActions,
}) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const actions = useMemo(() => {
    const all = [
      {
        key: "extractedMilk",
        icon: "🥛",
        name: t("quick_actions.add_extracted_milk"),
        onClick: onStartExtractedMilk,
        sx: { fontSize: "2rem", width: 80, height: 80 },
      },
      {
        key: "medicine",
        icon: "💊",
        name: "Medicin",
        onClick: onAddMedicine,
        sx: { fontSize: "2rem", width: 80, height: 80 },
      },
      {
        key: "tummyTime",
        icon: "🧸",
        name: activeTummyTime ? t("quick_actions.stop_tummy_time") : t("quick_actions.start_tummy_time"),
        onClick: activeTummyTime ? onStopTummyTime : onStartTummyTime,
        sx: activeTummyTime
          ? { bgcolor: "#f1828d", "&:hover": { bgcolor: "#f1828d" }, color: "#fff", fontSize: "2rem", width: 80, height: 80 }
          : { fontSize: "2rem", width: 80, height: 80 },
      },
      {
        key: "diaper",
        icon: "💩",
        name: t("quick_actions.add_diaper"),
        onClick: onStartDiaper,
        sx: { fontSize: "2rem", width: 80, height: 80 },
      },
      {
        key: "sleep",
        icon: "😴",
        name: activeSleep ? t("quick_actions.stop_sleep") : t("quick_actions.start_sleep"),
        onClick: activeSleep ? onStopSleep : onStartSleep,
        sx: activeSleep
          ? { bgcolor: "#f1828d", "&:hover": { bgcolor: "#f1828d" }, color: "#fff", fontSize: "2rem", width: 80, height: 80 }
          : { fontSize: "2rem", width: 80, height: 80 },
      },
      {
        key: "feeding",
        icon: "🍼",
        name: activeFeeding ? t("quick_actions.stop_feeding") : t("quick_actions.start_feeding"),
        onClick: activeFeeding ? onStopFeeding : onStartFeeding,
        sx: activeFeeding
          ? { bgcolor: "#f1828d", "&:hover": { bgcolor: "#f1828d" }, color: "#fff", fontSize: "2rem", width: 80, height: 80 }
          : { fontSize: "2rem", width: 80, height: 80 },
      },
    ];
    return visibleActions ? all.filter((a) => visibleActions.includes(a.key)) : all;
  }, [
    activeFeeding, onStartFeeding, onStopFeeding,
    activeSleep, onStartSleep, onStopSleep,
    activeTummyTime, onStartTummyTime, onStopTummyTime,
    onStartDiaper, onStartExtractedMilk, onAddMedicine, visibleActions, t,
  ]);

  return (
    <>
      <Backdrop open={open} />
      <SpeedDial
        ariaLabel="Quick actions"
        sx={{
          position: "fixed",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
        }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        FabProps={{
          sx: {
            bgcolor: darken("#7AA490", 0.2),
            "&:hover": {
              bgcolor: darken("#7AA490", 0.3),
            },
          },
        }}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => { action.onClick?.(); handleClose(); }}
            disabled={action.disabled}
            sx={action.sx}
          />
        ))}
      </SpeedDial>
    </>
  );
}
